<template>
  <v-timeline
    dense
    class="ma-3"
  >
    <v-timeline-item
      fill-dot
      class="white--text mb-5"
      color="primary"
      large
    >
      <template v-slot:icon>
        <v-icon dark>
          comment
        </v-icon>
      </template>
      <v-text-field
        v-model="input"
        :label="$t('Leave a comment...')"
        hide-details
        flat
        solo
        @keydown.enter="comment"
      >
        <template v-slot:append>
          <v-btn
            class="mx-0"
            depressed
            @click="comment"
          >
            {{ $t('Post') }}
          </v-btn>
        </template>
      </v-text-field>
    </v-timeline-item>
    <v-slide-y-transition group>
      <v-timeline-item
        v-for="(item, i) in timelineList"
        :key="i"
        color="primary"
        small
      >
        <OrderSingleTimelineItem
          :step="item"
          :index="i"
        />
      </v-timeline-item>
    </v-slide-y-transition>
  </v-timeline>
</template>

<script>
import OrderSingleTimelineItem from './OrderSingleTimelineItem'
export default {
  name: 'OrderSingleTimeline',

  components: {
    OrderSingleTimelineItem
  },

  props: {
    order: {
      type: Object,
      required: true
    }
  },

  data () {
    return {
      input: null,
      loadMore: false
    }
  },

  computed: {
    timelineList () {
      return this.order.comments
        .map(comment => {
          let message = ''

          if (!comment.text) {
            message = `Set order status: ${comment.status.charAt(0).toUpperCase() + comment.status.slice(1).replace('_', ' ')}`
          } else {
            message = comment.text
          }

          return {
            id: comment.id,
            title: message,
            date: comment.created_at,
            created_by: comment.created_by || 'system'
          }
        })
        .filter(comment => comment.title)
    }
  },

  methods: {
    comment () {
      this.$emit('add-comment', this.input)
      this.input = null
    }
  }
}
</script>
